import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import { AuthProvider } from './components/auth'
import { ToastProvider } from './contexts/ToastContext'
import { DrawerNavigationProvider } from './contexts/DrawerNavigationContext'
import { AnalyticsProvider } from './contexts/AnalyticsContext'
import { AppRouter } from './router/AppRouter'

// Initialize PostHog (production only)
const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY
const POSTHOG_HOST =
  import.meta.env.VITE_POSTHOG_HOST || 'https://app.posthog.com'
const ENV = import.meta.env.VITE_ENV

if (ENV === 'production' && POSTHOG_KEY) {
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
    disable_session_recording: false,
    respect_dnt: true,
    persistence: 'localStorage+cookie'
  })
}

function App() {
  return (
    <PostHogProvider client={posthog}>
      <AnalyticsProvider>
        <AuthProvider>
          <ToastProvider>
            <DrawerNavigationProvider>
              <AppRouter />
            </DrawerNavigationProvider>
          </ToastProvider>
        </AuthProvider>
      </AnalyticsProvider>
    </PostHogProvider>
  )
}

export default App
